import { AppForm } from '../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SmartgemRoadConditionReportRequestRoadConditionReportInputDto } from '../../../../../openapi';
import { dateToPLString } from '../../../../../services/helpers';

@Injectable()
export class ProvidingInformationAboutTravelConditionsForm extends AppForm {
  constructor() {
    super({
      origin: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      destination: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      extreme: new FormControl(false, { nonNullable: true }),
      allowableLoads: new FormControl(false, { nonNullable: true }),
      constructionsOrRepairs: new FormControl(false, { nonNullable: true }),
      maintenanceWorks: new FormControl(false, { nonNullable: true }),
      weatherConditions: new FormControl(false, { nonNullable: true }),
      cameras: new FormControl(false, { nonNullable: true }),

      geometry: new FormControl(null, Validators.required)
    });
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  public toWriteModel(): any {
    return {
      origin: this.value.origin,
      destination: this.value.destination,
      travelDate: new Date().toISOString().split('T')[0],
      extreme: this.value.extreme,
      allowableLoads: this.value.allowableLoads,
      constructionsOrRepairs: this.value.constructionsOrRepairs,
      maintenanceWorks: this.value.maintenanceWorks,
      weatherConditions: this.value.weatherConditions,
      cameras: this.value.cameras,
      geometry: this.geometry.value
    };
  }
}
